import React from 'react';

export default function SkeletonLoader({ width = "100%", height = "20px", borderRadius = "4px", count = 1 }) {
  const loaders = Array.from({ length: count });

  return (
    <>
      {loaders.map((_, index) => (
        <div
          key={index}
          className="skeleton-loader"
          style={{ width, height, borderRadius }}
        />
      ))}
    </>
  );
}
